import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/plugins/element-ui";
import "@/plugins/ajx-common";
import "@/plugins/modal";
import "@/assets/styles/common.scss";
import "@/assets/styles/reset-element.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
